/* MAISON ROTEA GALLERY CLEAN V5 */
(() => {
  if (window.RoteaGalleryCleanV5) return;
  window.RoteaGalleryCleanV5 = true;

  const desktop = window.matchMedia("(min-width: 990px)");

  function init(root = document) {
    const galleries = [];

    if (
      root.matches &&
      root.matches(".product--thumbnail_slider media-gallery")
    ) {
      galleries.push(root);
    }

    root.querySelectorAll?.(
      ".product--thumbnail_slider media-gallery"
    ).forEach(g => galleries.push(g));

    galleries.forEach(gallery => {
      if (gallery.dataset.roteaExpandReady === "true") return;

      const viewer = gallery.querySelector(
        'slider-component[id^="GalleryViewer-"]'
      );

      const list = viewer?.querySelector(
        ".product__media-list"
      );

      if (!viewer || !list) return;

      const getItems = () => Array.from(list.children)
        .filter(el => el.classList.contains(
          "product__media-item"
        ));

      const items = getItems();

      if (items.length <= 4) return;

      gallery.dataset.roteaExpandReady = "true";

      const button = document.createElement("button");
      button.type = "button";
      button.className = "rotea-gallery-expand-button";
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-controls", list.id);

      const label = document.createElement("span");
      label.textContent =
        `Voir toutes les photos (${items.length})`;

      button.appendChild(label);

      button.insertAdjacentHTML("beforeend", `
        <svg viewBox="0 0 24 24"
             fill="none"
             stroke="currentColor"
             stroke-width="1.5"
             stroke-linecap="round"
             stroke-linejoin="round"
             aria-hidden="true">
          <path d="M6 9l6 6 6-6"/>
        </svg>
      `);

      // IMPORTANT :
      // Le bouton est inséré directement dans le
      // slider-component, après ses contrôles natifs.
      // Il reste donc sous la grille, dans le flux HTML.
      viewer.appendChild(button);

      let expanded = false;

      function expand() {
        if (expanded) return;

        expanded = true;
        gallery.classList.remove(
          "rotea-gallery-collapsed"
        );

        button.setAttribute("aria-expanded", "true");
        button.hidden = true;
      }

      button.addEventListener("click", expand);

      function checkActive() {
        if (!desktop.matches || expanded) return;

        const current = getItems();

        const activeIndex = current.findIndex(item =>
          item.classList.contains("is-active")
        );

        // Si Shopify active une image cachée,
        // on développe la galerie.
        if (activeIndex >= 4) expand();
      }

      const observer = new MutationObserver(checkActive);

      observer.observe(list, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"]
      });

      // Ne jamais masquer l'image active.
      checkActive();

      if (!expanded) {
        gallery.classList.add(
          "rotea-gallery-collapsed"
        );
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => init()
    );
  } else {
    init();
  }

  document.addEventListener(
    "shopify:section:load",
    event => init(event.target)
  );
})();
